export default {
    'onboarding': {
        component: import('@/views/integrations/protokol/ecommerce/Onboarding')
    }
}